import { useState, useEffect } from 'react';
import axios from 'axios';
import Pagination from '../../../component/Admin/Pagination';
import { FaEdit, FaFilter, FaMoneyCheck, FaMoneyCheckAlt, FaTrashAlt, FaUndoAlt, FaChevronDown, FaChevronUp } from 'react-icons/fa';
// import Loading from '../../../component/Loading';
import 'react-quill/dist/quill.snow.css';
import { formatDate } from '../../../helper/helper';
import Invoice from '../../../component/Admin/Payment/Invoice';
import { NavLink } from 'react-router-dom';
import TableBasic from '../../../component/Admin/TableBasic';
import Swal from 'sweetalert2';
import { canAccess } from '../../../helper/permissions';


const Payment = ({ data }) => {

    const header = {
        headers: { 'Authorization': `Bearer ${data.token}` }
    }
    const permissions = data?.user?.permissions || {};
    const canEdit = canAccess(permissions, 'payment', 'edit');
    const canDelete = canAccess(permissions, 'payment', 'delete');
    const [listPayment, setListPayment] = useState([]);
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [invoiceIsOpen, setInvoiceIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState(null);
    const [search, setSearch] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [isFilterCollapsed, setIsFilterCollapsed] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ASC' });

    useEffect(() => {
        getListPayment();
        // eslint-disable-next-line
    }, [page, limit, search, selectedStatus, sortConfig]);

    const getListPayment = () => {
        // setLoadingSmall(true)
        const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
        const statusParam = selectedStatus ? `&status=${encodeURIComponent(selectedStatus)}` : '';
        const sortParam = sortConfig?.key ? `&sortBy=${encodeURIComponent(sortConfig.key)}&sortDir=${encodeURIComponent(sortConfig.direction)}` : '';
        axios.get(`api/payment?page=${page}&limit=${limit}${searchParam}${statusParam}${sortParam}`, header)
            .then((response) => {
                setMeta(response.data.meta);
                setListPayment(response.data.items);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const handleFilterStatusChange = (event) => {
        setSelectedStatus(event.target.value);
        setPage(1);
    };

    const handleResetFilters = () => {
        setSelectedStatus('');
        setSearch('');
        setPage(1);
    };

    const handleSort = (key) => {
        setSortConfig((prev) => {
            if (prev.key === key) {
                const nextDirection = prev.direction === 'ASC' ? 'DESC' : 'ASC';
                return { key, direction: nextDirection };
            }
            return { key, direction: 'ASC' };
        });
        setPage(1);
    };




    const selectPage = (value) => {
        setPage(value);
    };

    const nextPage = () => {
        if (page < meta.totalPages) {
            setPage(page + 1);
        }
    };

    const prevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const limitPage = (event) => {
        setLimit(Number(event.target.value));
        setPage(1);
    };








    const handleClickInvoice = (trxID) => {
        const data = listPayment.filter(item => {
            return item.trxID === trxID;
        });
        if (data.length > 0) {
            setSelectedItems(data[0]);
            setInvoiceIsOpen(true);
        } else {
            setSelectedItems(null);
            setInvoiceIsOpen(false);
        }
    }


    const closeInvoice = () => {
        setSelectedItems({
            Payment_name: "",
            message: "",
            Payment_manager: "",
            Payment_path: "",
            header: "",
        }); // Reset modal data for new entry
        setInvoiceIsOpen(false);
    }

    const handleDelete = (paymentID) => {
        Swal.fire({
            title: 'Hapus Payment?',
            text: 'Tindakan ini tidak dapat dibatalkan.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#5C5E62',
            confirmButtonText: 'Ya, hapus',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`api/payment/${paymentID}`, header)
                    .then(() => {
                        // Optimistic update: remove from list without refetch
                        setListPayment((prev) => prev.filter(p => p.paymentID !== paymentID));
                        Swal.fire({
                            message: 'Success',
                            icon: 'success',
                            text: 'Payment berhasil dihapus',
                            confirmButtonText: 'Tutup',
                            confirmButtonColor: '#4569ab',
                        });
                        // Refresh list to ensure consistency
                        getListPayment();
                    })
                    .catch((error) => {
                        console.error('Error deleting data:', error);
                        Swal.fire({
                            title: 'Gagal',
                            text: 'Terjadi kesalahan saat menghapus data.',
                            icon: 'error'
                        });
                    });
            }
        });
    }


    const head = [
        { name: 'No.', align: 'center' },
        { name: 'Transaction ID', align: 'left', key: 'trxID', sortable: true },
        { name: 'Name Transaction', align: 'left', key: 'paymentName', sortable: true },
        { name: 'Name Customer', align: 'left', key: 'customerName', sortable: true },
        { name: 'LOA', align: 'left' },
        { name: 'Payment Status', align: 'center', key: 'paymentStatus', sortable: true },
        { name: 'Create At', align: 'left', key: 'createAt', sortable: true },
        { name: 'Action', align: 'center' },
    ];


    return (
        <>
            {/* {loading ? <Loading /> : null} */}

            <div className="mb-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
                <div className="flex flex-wrap items-center gap-2 px-3 py-2.5">
                    <div className="relative min-w-[200px] flex-1">
                        <svg viewBox="0 0 192.904 192.904" className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" fill="currentColor">
                            <path d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 0 0 5.303 2.197 7.498 7.498 0 0 0 5.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z" />
                        </svg>
                        <input
                            id="search"
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                            type="text"
                            placeholder="Cari transaksi..."
                            className="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/60 py-2 pl-9 pr-3 text-sm text-gray-800 dark:text-gray-200 placeholder-gray-400 outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                        />
                    </div>

                    <button
                        type="button"
                        onClick={() => setIsFilterCollapsed(!isFilterCollapsed)}
                        className={`pill ${!isFilterCollapsed ? 'pill-active' : 'pill-inactive'}`}
                    >
                        <FaFilter className="h-3.5 w-3.5" />
                        Filter
                        {isFilterCollapsed ? (
                            <FaChevronDown className="h-3 w-3 opacity-80" />
                        ) : (
                            <FaChevronUp className="h-3 w-3 opacity-80" />
                        )}
                    </button>
                </div>

                {!isFilterCollapsed && (
                    <div className="flex flex-wrap items-end gap-2.5 border-t border-gray-100 dark:border-gray-700 px-3 py-2.5">
                        <div className="min-w-[140px] flex-1 sm:flex-none sm:w-[160px]">
                            <label htmlFor="status" className="mb-1 block text-left text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Status</label>
                            <select
                                id="status"
                                value={selectedStatus}
                                onChange={handleFilterStatusChange}
                                className="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 px-2.5 py-2 text-sm text-gray-800 dark:text-gray-200 outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                            >
                                <option value="">Semua</option>
                                <option value="pending">Pending</option>
                                <option value="lunas">Lunas</option>
                                <option value="failed">Failed</option>
                            </select>
                        </div>
                        <button
                            type="button"
                            onClick={handleResetFilters}
                            title="Reset filter"
                            className="inline-flex h-[38px] items-center gap-1.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 px-3 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
                        >
                            <FaUndoAlt className="h-3.5 w-3.5" />
                            Reset
                        </button>
                    </div>
                )}
            </div>

            <TableBasic head={head} onSort={handleSort} sortConfig={sortConfig} >
                {listPayment.length > 0 ? (
                    listPayment.map((item, index) => {
                        const bg_status = item.paymentStatus === 'lunas' ? "bg-green-100 text-green-800 border-green-200" : "bg-yellow-100 text-yellow-800 border-yellow-200"
                        return (
                            <tr key={index} className="hover:bg-gradient-to-r hover:from-gray-50 hover:to-white dark:hover:from-gray-700 dark:hover:to-gray-600 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 transition-all duration-200">
                                <td className="text-sm font-medium text-center px-4 py-4 text-gray-700 dark:text-gray-300">{(page - 1) * limit + index + 1}</td>
                                <td className="text-sm px-3 py-3 whitespace-nowrap text-left font-semibold text-primary dark:text-primary-on-dark">{item.trxID}</td>
                                <td className="text-sm px-3 py-3 text-left text-gray-900 dark:text-gray-100">{item.paymentName}</td>
                                <td className="text-sm px-3 py-3 text-left text-gray-700 dark:text-gray-300">{item.customerName}</td>
                                <td className="text-sm px-3 py-3 whitespace-nowrap text-left">
                                    {item.loa_id ? (
                                        <div className="text-xs">
                                            <div className="font-semibold text-primary dark:text-gray-200">{item.loa_submitID || '-'}</div>
                                            <div className="text-gray-600 dark:text-gray-400">
                                                Vol. {item.loa_volume || '-'}, Issue {item.loa_issue || '-'}
                                            </div>
                                            <div className="text-gray-500 dark:text-gray-400">
                                                {item.loa_month || '-'} {item.loa_year || ''}
                                            </div>
                                        </div>
                                    ) : (
                                        <span className="text-gray-400 dark:text-gray-500">-</span>
                                    )}
                                </td>
                                <td className="text-sm px-3 py-3 whitespace-nowrap text-center">
                                    <span className={`${bg_status} ${item.paymentStatus === 'lunas' ? 'dark:bg-green-900/30 dark:text-green-400 dark:border-green-700' : 'dark:bg-yellow-900/30 dark:text-yellow-400 dark:border-yellow-700'} rounded-full py-1.5 px-4 font-semibold text-xs border-2`}>
                                        {item.paymentStatus}
                                    </span>
                                </td>
                                <td className="text-sm px-3 py-3 whitespace-nowrap text-left text-gray-600 dark:text-gray-400">{formatDate(item.createAt)}</td>

                                <td className="sticky right-0 z-10 whitespace-nowrap bg-white text-center shadow-[-6px_0_10px_-8px_rgba(0,0,0,0.35)] md:static md:shadow-none dark:bg-gray-800">
                                    <div className="inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-gray-50 p-0.5 shadow-sm dark:border-gray-600 dark:bg-gray-700/60">
                                        {item.paymentStatus === 'pending' ? (
                                            <NavLink
                                                to={`/admin/payment/bill/${item.trxID}`}
                                                className="flex items-center justify-center rounded-md p-2 text-link transition-all duration-200 hover:bg-primary/10 dark:hover:bg-primary/30"
                                                title="Bill"
                                            >
                                                <FaMoneyCheckAlt className="w-4 h-4" />
                                            </NavLink>
                                        ) : (
                                            <NavLink
                                                to={`/admin/payment/invoice/${item.trxID}`}
                                                className="flex items-center justify-center rounded-md p-2 text-green-600 transition-all duration-200 hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/30"
                                                title="Invoice"
                                            >
                                                <FaMoneyCheck className="w-4 h-4" />
                                            </NavLink>
                                        )}
                                        {canEdit ? (
                                            <NavLink
                                                to={`${item.trxID}`}
                                                className="flex items-center justify-center rounded-md p-2 text-link transition-all duration-200 hover:bg-primary/10 dark:hover:bg-primary/30"
                                                title="Detail"
                                            >
                                                <FaEdit className="w-4 h-4" />
                                            </NavLink>
                                        ) : null}
                                        {canDelete ? (
                                            <button
                                                type="button"
                                                className="flex items-center justify-center rounded-md p-2 text-red-600 transition-all duration-200 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/30"
                                                onClick={() => handleDelete(item.paymentID)}
                                                title="Hapus Payment"
                                            >
                                                <FaTrashAlt className="w-4 h-4" />
                                            </button>
                                        ) : null}
                                    </div>
                                </td>
                            </tr>
                        )
                    })
                ) : (
                    <tr className="bg-white border-b">
                        <td colSpan={8} className="px-6 py-12 whitespace-nowrap">
                            <div className='flex justify-center items-center'>
                                <div className='text-center'>
                                    <div className="text-4xl mb-2">📭</div>
                                    <div className="text-xl font-semibold text-gray-400">Data Tidak Ditemukan</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                )}
            </TableBasic>
            <Pagination
                currentPage={page}
                totalPages={meta.totalPages}
                limit={limit}
                limitPage={limitPage}
                selectPage={selectPage}
                nextPage={nextPage}
                prevPage={prevPage}
            />
            {/* <PaymentForm // Use the new modal component
                isOpen={formIsOpen}
                closeModal={closeModal}
                selectedItems={selectedItems}
                handleSubmit={handleSubmit}
            /> */}
            <Invoice
                isOpen={invoiceIsOpen}
                closeInvoice={closeInvoice}
                selectedItems={selectedItems}
                token={data.token}
            />
        </>
    );
};

export default Payment;